import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

/** Reads `PLATFORM.DEV_TOGGLES.SHOW_NEW_ISSUE_DETAILS_MODAL` from central config. */
export const useShowNewIssueDetailsModal = (): boolean => {
	const { configuration } = useConfiguration();
	return configuration?.PLATFORM?.DEV_TOGGLES?.SHOW_NEW_ISSUE_DETAILS_MODAL === true;
};
